import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Card, Container, Row, Col, CardBody, CardHeader } from 'react-bootstrap'
import Loader3 from '../../../../CommonElements/Spinner/loader3'
import SkeletonLoader from '../../../../CommonElements/Spinner/SkeletonLoader'
import { RecentOrderChart } from "./analytics_data_temp";
import ReactApexChart from "react-apexcharts";
import { ArrowDown, ArrowUp } from "react-feather";
import "../AIModelReports/custom.css";
import { getWeek } from "../../../../_helper/helper";
import ApexInteractiveHeatmap from "./components/HeatMap";
import ProgressBars from "./components/ProgressBars";
import AlertsTrendChart from "./components/AlertsTrendChart";
import AreaService from "../../../../api/areaService";
import { getCurrentWeekNumber } from "../../../../utils/getCurrentWeekNumber";
import CameraService from "../../../../api/cameraService";
import { getCurrentWeekWithYear } from "../../../../utils/currentWeekWithYear";
import { analyticsPageService } from "../../../../api/analyticsPageService";
import AccuracyCardDesign from "./New componens/Cards/AccuracyCardDesign";
import HeroSection2 from "./New componens/HeroSection2";

// new grapghs
import Newprogresbar from './New componens/Grapgh/ProgressBar'
import NewDonutChart2 from './New componens/Grapgh/NewDonutChart2'
import NewHeatMap from "./New componens/Grapgh/NewHeatMap";
import NewBarChart2 from "./New componens/Grapgh/NewBarChart2";
import { useWindowSize } from './New componens/CustomHook/Check_Screen_Width'
import LiveAnalyticsContext from "../../../../_helper/formData/LiveAnalytics/LiveAnalytics";
import DynamicModulesContext from "../../../../_helper/formData/DynamicModules/DynamicModulesContext";

const AnalyticsPage = ({ filters }) => {
    const { width } = useWindowSize();
    const [loadingForDonut, setLoadingForDonut] = useState(true)
    const [loadingForBars, setLoadingForBars] = useState(false)
    const [heatmapLoader, setHeatmapLoader] = useState(true)
    const [connectivityFactoryLoader, setconnectivityFactoryLoader] = useState(true)
    const [acuuracyLoader, setAccuracyLoader] = useState(true)
    const [accuracyPercent, setAccuracyPercent] = useState()
    const [recentOrderChart, setRecentOrderChart] = useState(RecentOrderChart)
    const [progressData, setProgressData] = useState(undefined);
    const [week, setWeek] = useState(null);
    const [loader, setLoader] = useState(false);
    const [chartData, setChartData] = useState({
        categories: [],
        series: [],
    });
    const [factoryCamerasCount, setfactoryCamerasCount] = useState();
    const [heatmapData, setHeatmapData] = useState({});
    const [acceptedRecords, setAccptedRecords] = useState()
    const [totalRecords, setTotalRecords] = useState()
    const [acknowledgedCount, setacknowledgedCount] = useState({
        acceptedRecords: undefined,
        pending: undefined,
        totalRecords: undefined,
        not_an_alert: undefined
    })
    const [highseverityCardData, sethighseverityCardData] = useState({
        max_alerts: '',
        highSeverity: ''
    })
    const [highseverityCardLoader, sethighseverityCardLoader] = useState(true)
    const [HighestNonComplianceArea, setHighestNonComplianceArea] = useState('')
    const [highestAlertModule, setHighestAlertModule] = useState(null);
    const [highestAlertOwner, setHighestAlertOwner] = useState(null);
    const [maxValue, setMaxValue] = useState({
        highSeverityTotalAlerts: 0,
        mediumPlusSeverityAlerts: 0,
        main: 0,
        violationType: '',
        alertLeft: 0,
        alertRight: 0,
        violationArea: '',
        violation_areaOwner: ''
    })

    const {
        setOverAllComplaince,
        setProgressContext,
        setAiAccuracyContext,
        setCameraCountContext,
        setheatdatacontext,
        setdashfiltercontext,
    } = useContext(LiveAnalyticsContext)
    const { AllActiveModules } = useContext(DynamicModulesContext);

    const [factoryID] = useState(JSON.parse(localStorage.getItem('userData'))?.factory.id || 0)

    useEffect(() => {
        setHeatmapLoader(true);
        fetchAnalyticsBars();
        modelAccuracy();
        setLoader(true);
        fetchHeatmapData();
        getfactorycamerascount();
    }, [filters]);

    function getMaxAlertModuleWithSeverity(heatmapData) {
        // Predefined severity arrays
        const highSeverityModules = ["Emergency Exit", "MMHE", "No Go Area"];
        const mediumSeverityModules = ["Helmet", "Vest", "Machine Guard", "Arcsuit"];

        if (!heatmapData || typeof heatmapData !== 'object') {
            throw new Error("Invalid input: heatmapData must be an object");
        }

        const hd = heatmapData.heatmapData;
        if (!hd) throw new Error("Missing 'heatmapData' key");

        const { areas, subAreas, areaOwner, data } = hd;

        if (!Array.isArray(areas) || !Array.isArray(subAreas) || !Array.isArray(areaOwner) || !Array.isArray(data)) {
            throw new Error("Invalid structure: 'areas', 'subAreas', 'areaOwner', and 'data' must be arrays");
        }

        if (areas.length !== subAreas.length || areas.length !== areaOwner.length) {
            throw new Error("Length mismatch between 'areas', 'subAreas', and 'areaOwner'");
        }

        let maxAlert = -Infinity;
        let result = {
            max_alert_count: 0,
            module_name: null,
            area_name: null,
            subarea_name: null,
            area_owner: null,
            total_alerts: 0,
            highSeverityAlerts: 0,
            mediumSeverityAlerts: 0
        };

        data.forEach(module => {
            if (!module.name || !Array.isArray(module.data)) return;

            const totalAlerts = module.data.reduce((sum, val) => sum + (val > 0 ? val : 0), 0);

            module.data.forEach((alertCount, index) => {
                if (alertCount > maxAlert) {
                    maxAlert = alertCount;
                    result.max_alert_count = alertCount;
                    result.module_name = module.name;
                    result.area_name = areas[index] || null;
                    result.subarea_name = subAreas[index] || null;
                    result.area_owner = areaOwner[index] || null;
                    result.total_alerts = totalAlerts;
                }
            });

            if (highSeverityModules.includes(module.name)) {
                result.highSeverityAlerts += totalAlerts;
            } else if (mediumSeverityModules.includes(module.name)) {
                result.mediumSeverityAlerts += totalAlerts;
            }
        });

        if (result.module_name === null) {
            throw new Error("No valid module data found");
        }

        return result;
    }

    async function fetchAnalyticsBars() {
        setLoadingForBars(true);
        setLoadingForDonut(true);
        const userID = JSON.parse(localStorage.getItem("userData"))?.id;
        const fils = JSON.parse(localStorage.getItem("dashfilters"));
        try {
            const payload = {
                ...fils,
                areaname: "",
                area_ids: [],
                user_id: userID,
                factory_id: factoryID,
            };
            const res = await AreaService.fetchAnalyticsProgressGbl(payload);
            if (res.status == 200) {
                const FacotryModules = AllActiveModules || []
                const Factory_Assign_Module = res?.data?.progressData.filter((item) =>
                    FacotryModules.includes(item.name)
                );
                const validBarValues = Factory_Assign_Module.filter(
                    (item) => item.barValue > 0
                );
                const totalBarValue = validBarValues.reduce(
                    (sum, item) => sum + item.barValue,
                    0
                );
                const averageBarValue =
                    validBarValues.length > 0 ? totalBarValue / validBarValues.length : 0;

                setRecentOrderChart((recentOrderChart) => ({
                    ...recentOrderChart,
                    series: [averageBarValue?.toFixed(1)],
                }));

                setOverAllComplaince(Math.round(averageBarValue).toFixed(0));

                const updatedData = Factory_Assign_Module.map((item) => ({
                    ...item,
                    tooltipContent: [
                        {
                            label: "Max Alerts by",
                            value: `${item.area_with_max_alerts ? item.area_with_max_alerts : "N/A"
                                } ${item.area_owner ? `(${item.area_owner})` : ""} `,
                        },
                        { label: "Sub Area", value: `${item.subarea_with_max_alerts}` },
                        { label: "Max Alerts ", value: `${item.max_alerts}` },
                        { label: "Total Alerts ", value: `${item.alerts}` },
                    ],
                }));

                setProgressData(updatedData);
                setProgressContext(updatedData);
            }
            setLoadingForBars(false);
            setLoadingForDonut(false);
        } catch (err) {
            console.log("Analytics page, Progress bars section error", err);
            setLoadingForBars(false);
            setLoadingForDonut(false);
        }
    }

    useEffect(() => {
      
     let fils = JSON.parse(localStorage.getItem("dashfilters"));

        if (!fils) {
            localStorage.setItem("dashfilters", JSON.stringify(filters));
            fils = JSON.parse(localStorage.getItem("dashfilters"));
        }

        if (!Array.isArray(fils.shift)) {
            fils.shift = fils.shift ? [String(fils.shift)] : [];
            localStorage.setItem("dashfilters", JSON.stringify(fils));
        }
      
    }, [])
    

    async function fetchHeatmapData() {
        const userID = JSON.parse(localStorage.getItem("userData"))?.id || "";
        let fils = JSON.parse(localStorage.getItem("dashfilters"));

        if (!fils) {
            localStorage.setItem("dashfilters", JSON.stringify(filters));
            fils = JSON.parse(localStorage.getItem("dashfilters"));
        }

        if (!Array.isArray(fils.shift)) {
            fils.shift = fils.shift ? [String(fils.shift)] : [];
            localStorage.setItem("dashfilters", JSON.stringify(fils));
        }

        let payload = {
            ...fils,
            user_id: userID,
            factory_id: factoryID,
        };

        try {
            setHeatmapLoader(true);
            setdashfiltercontext((prev) => ({
                ...prev,
                month: payload.month,
                weekly: payload.weekly,
                shift: payload.shift
            }))

            let res = await AreaService.fetchAnalyticsHeatmapGbl(payload)
            if (res?.status == 200) {
                const FactoryModules = AllActiveModules || []
                const filteredData = res?.data?.heatmapData?.data.filter(item => FactoryModules.includes(item.name));
                const HeatMapUpdatedData = {
                    ...res?.data?.heatmapData,
                    data: filteredData
                }
                setHeatmapData(HeatMapUpdatedData);
                const max_alert_count = getMaxAlertModuleWithSeverity(res?.data);

                setMaxValue(prev => ({
                    ...prev,
                    main: max_alert_count?.total_alerts || 0,
                    violationType: max_alert_count?.module_name || "N/A",
                    violationArea: max_alert_count?.area_name || "N/A",
                    violation_areaOwner: max_alert_count?.area_owner || "N/A",
                    alertLeft: max_alert_count?.max_alert_count || 0,
                    highSeverityTotalAlerts: max_alert_count?.highSeverityAlerts || 0,
                    mediumPlusSeverityAlerts: max_alert_count?.mediumSeverityAlerts || 0
                }));

                setheatdatacontext(res?.data?.heatmapData)
            }
            setHeatmapLoader(false);
            sethighseverityCardLoader(false);
        } catch (err) {
            console.log("Analytics page, Heatmap chart error", err);
            setHeatmapLoader(false);
        }
    }

    const getfactorycamerascount = async () => {
        setconnectivityFactoryLoader(true);
        try {
            const res = await CameraService.factoryCameras(factoryID);
            if (res) {
                setfactoryCamerasCount(res.data.data);
                setCameraCountContext(res?.data?.data);
                setconnectivityFactoryLoader(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    async function modelAccuracy() {
        setAccuracyLoader(true);
        const pID = JSON.parse(localStorage.getItem("userData"))?.id;
         let fils = JSON.parse(localStorage.getItem("dashfilters"));

        if (!fils) {
            localStorage.setItem("dashfilters", JSON.stringify(filters));
            fils = JSON.parse(localStorage.getItem("dashfilters"));
        }

        if (!Array.isArray(fils.shift)) {
            fils.shift = fils.shift ? [String(fils.shift)] : [];
            localStorage.setItem("dashfilters", JSON.stringify(fils));
        }

        const payload = {
            user_id: pID,
            identifier: fils.weekly ? "week" : "month",
            factory_id: factoryID,
            role: JSON.parse(localStorage.getItem('role')),
            filters: {
                approval: "",
                module: "",
                severity: "",
                shift: fils.shift,
                date: "",
                week: fils.weekly,
                month: fils.month,
                starting: "",
                ending: "",
                area: "",
                subarea: "",
            },
            pagination: {
                page_no: 1,
                per_page: 21,
            },
        };

        try {
            const res = await AreaService.getFilterAlerts(payload);
            if (res?.statusText?.toLocaleLowerCase() == "ok") {
                const accepted = res?.data?.data?.accepted_aitechqa_records;
                const total = res?.data?.data?.total_records;
                const newAccepted = res?.data?.data?.accepted_records
                setAccptedRecords(newAccepted)

                setacknowledgedCount({
                    acceptedRecords: res?.data?.data["Total Acknowledged"],
                    pending: res?.data?.data["Total Unacknowledged"],
                    totalRecords: res?.data?.data.total_records,
                    not_an_alert: res?.data?.data.total_not_an_alert_count
                });
                setTotalRecords(total)
                const rejected = res?.data?.data?.rejected_aitechqa_records;
                const percentage_new = (accepted / (accepted + rejected)) * 100;

                setAccuracyPercent(Math.round(percentage_new));
                setAiAccuracyContext(Math.round(percentage_new));
            }
            setAccuracyLoader(false);
        } catch (err) {
            console.log("Ai accuracy error", err);
            setAccuracyLoader(false);
        }
    }

    return (
        <Fragment>


            {/* Hero section cards */}

            {width < 1400 ?
                <Row>
                    <HeroSection2
                        connectivityFactoryLoader={connectivityFactoryLoader}
                        factoryCamerasCount={factoryCamerasCount}
                        acuuracyLoader={acuuracyLoader}
                        accuracyPercent={accuracyPercent}
                        heatmapLoader={heatmapLoader}
                        highseverityCardLoader={highseverityCardLoader}
                        highseverityCardData={highseverityCardData}
                        maxValue={maxValue}
                        filters={filters}
                        HighestNonComplianceArea={HighestNonComplianceArea}
                        highestAlertModule={highestAlertModule}
                        highestAlertOwner={highestAlertOwner}
                        width={width}
                    />
                    <Col xs='12' >
                        <Card className="px-3" style={{ borderRadius: '24px' }}>
                            <Row>
                                <Col xxl='12' lg='6' md='12' className={` d-flex justify-content-center`}>

                                    <NewDonutChart2 width={width} seriess={recentOrderChart.series} tooltip={progressData} />
                                </Col>
                                <Col xxl='12' lg='6' md='12' className="">

                                    <NewBarChart2
                                        progressData={progressData}
                                        width={width}
                                        week={week}
                                        loadingForBars={loadingForBars}
                                        filters={filters}
                                    />
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                    <Col xs='12'>
                        <AlertsTrendChart
                            chartData={chartData}
                            filters={filters}
                        />
                    </Col>
                    <Col xs='12'>
                        <NewHeatMap
                            heatmapData={heatmapData}
                            moduleLength={progressData?.length}
                            loader={heatmapLoader}
                            filters={filters}
                        />
                    </Col>

                </Row> : <>
                    <Row style={{
                        overflowY: 'hidden' }}>
                        {/* First Column - Sticky */}
                        <Col xxl='4' >
                            <Card
                                className="px-3 m-0"
                                style={{
                                    borderRadius: '24px',
                                }}
                            >
                                <Row style={{ height: '100%' }}>
                                    <Col xxl='12' lg='6' md='12'>
                                        <NewDonutChart2 seriess={recentOrderChart.series} tooltip={progressData} />
                                    </Col>
                                    <Col xxl='12' lg='6' md='12'>
                                        <NewBarChart2
                                            progressData={progressData}
                                            week={week}
                                            loadingForBars={loadingForBars}
                                            filters={filters}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* Second Column - Scrollable */}
                        <Col xxl='8' className="pb-2 " style={{ overflowY: 'auto',
                            }}>
                            <style jsx>{`
                                .custom-scroll {
                                    /* Firefox */
                                    scrollbar-width: thin;
                                    scrollbar-color: #175fa4 #f1f1f1;
                                }

                                /* Webkit browsers (Chrome, Safari, Edge) */
                                .custom-scroll::-webkit-scrollbar {
                                    width: 8px; /* Width of the scroll bar */
                                }

                                .custom-scroll::-webkit-scrollbar-thumb {
                                    background-color: #175fa4; /* Color of the thumb */
                                    border-radius: 10px; /* Rounded corners of the thumb */
                                }

                                .custom-scroll::-webkit-scrollbar-track {
                                    background-color: #f1f1f1; /* Background color of the track */
                                }
                                `}</style>
                            <Row>
                                <HeroSection2
                                    connectivityFactoryLoader={connectivityFactoryLoader}
                                    factoryCamerasCount={factoryCamerasCount}
                                    acuuracyLoader={acuuracyLoader}
                                    accuracyPercent={accuracyPercent}
                                    heatmapLoader={heatmapLoader}
                                    highseverityCardLoader={highseverityCardLoader}
                                    highseverityCardData={highseverityCardData}
                                    maxValue={maxValue}
                                    filters={filters}
                                    HighestNonComplianceArea={HighestNonComplianceArea}
                                    highestAlertModule={highestAlertModule}
                                    highestAlertOwner={highestAlertOwner}
                                />
                                <Col xs='12'>
                                    <AlertsTrendChart
                                        chartData={chartData}
                                        filters={filters}
                                    />
                                </Col>
                                <Col xs='12'>
                                    <NewHeatMap
                                        heatmapData={heatmapData}
                                        moduleLength={progressData?.length}
                                        loader={heatmapLoader}
                                        filters={filters}
                                    />
                                </Col>

                            </Row>
                        </Col>
                    </Row>

                </>}
        </Fragment>
    );
};

export default AnalyticsPage;
